import * as React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class TableActions extends React.Component {
  renderButton(action, index) {
    const { data } = this.props;

    if (typeof action === 'function') {
      // eslint-disable-next-line no-param-reassign
      action = action(data);
      if (!action) {
        return null;
      }
    }
    if (!action.isRowAction) return null;
    return (
      <Button
        aria-label={action.tooltip}
        className="btn-icon rounded-circle"
        color="light"
        disabled={action.disabled}
        key={`${action.icon} ${index}`}
        onClick={event => {
          if (action.onClick) {
            action.onClick(event, data);
            event.stopPropagation();
          }
        }}
        title={action.tooltip}
      >
        <FontAwesomeIcon icon={action.icon} />
      </Button>
    );
  }

  render() {
    const { actions } = this.props;
    if (actions) {
      return actions.map((action, index) => this.renderButton(action, index));
    }

    return null;
  }
}

TableActions.defaultProps = {
  actions: [],
  data: {},
};

TableActions.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  ),
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object),
  ]),
};

export default TableActions;
